import React, { useEffect, useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { post, put } from "src/services/httpClient.service";
import { authenticationService } from "src/services";
import { useSnackbar } from "src/components/snackbar/useSnackbar";

const PaymentGatewayForm = ({ handleClose, fetchCategories, updateData }) => {
  const API_URL = process.env.REACT_APP_BASE_API_URL;

  const { vendorId, franchiseId } =
    authenticationService.getVendorFranchiseIds();

  const { showSnackbar } = useSnackbar();

  const isEdit = !!updateData?.id;

  /* ---------- STATE ---------- */
  const [paymentGateway, setPaymentGateway] = useState("");
  const [jsonConfig, setJsonConfig] = useState("{}");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  /* ---------- LOAD EDIT DATA ---------- */
  useEffect(() => {
    if (isEdit) {
      setPaymentGateway(updateData.paymentType || "");

      try {
        const parsed = updateData.details
          ? JSON.parse(updateData.details)
          : {};

        setJsonConfig(JSON.stringify(parsed, null, 2));
      } catch {
        setJsonConfig("{}");
      }
    }
  }, [updateData]);

  /* ---------- VALIDATION ---------- */
  const validateJson = (val) => {
    try {
      JSON.parse(val);
      return true;
    } catch {
      return false;
    }
  };

  const beautifyJson = (val) => {
    try {
      return JSON.stringify(JSON.parse(val), null, 2);
    } catch {
      return val;
    }
  };

  /* ---------- SUBMIT ---------- */
  const handleSubmit = async () => {
    if (!paymentGateway) {
      showSnackbar("Payment Gateway is required", "error");
      return;
    }

    if (!validateJson(jsonConfig)) {
      setError(true);
      showSnackbar("Invalid JSON format", "error");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        ...(isEdit && { id: updateData.id }),
        paymentType: paymentGateway,
        details: JSON.stringify(JSON.parse(jsonConfig)), // 🔥 dynamic JSON 그대로
        vendorId,
        franchiseId,
      };

      console.log("📤 Payload:", payload);

      const response = isEdit
        ? await put(`${API_URL}/api/payment-gateway/update`, payload)
        : await post(`${API_URL}/api/payment-gateway/create`, payload);

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        showSnackbar(response?.message || "Success", "success");
      } else {
        showSnackbar(response?.message || "Failed", "error");
      }

      fetchCategories?.();
      handleClose?.();
    } catch (err) {
      console.error(err);
      showSnackbar("Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      {/* <Typography variant="h6" sx={{ mb: 2 }}>
        {isEdit ? "Update" : "Add"} Payment Gateway
      </Typography> */}

      {/* Dropdown */}
      <FormControl fullWidth margin="normal">
        <InputLabel>Payment Gateway</InputLabel>
        <Select
          value={paymentGateway}
          onChange={(e) => setPaymentGateway(e.target.value)}
        >
          <MenuItem value="Stripe">Stripe</MenuItem>
          <MenuItem value="RazorPay">RazorPay</MenuItem>
          <MenuItem value="PayPal">PayPal</MenuItem>
          <MenuItem value="PayU">PayU</MenuItem>
          <MenuItem value="CCAvenue">CCAvenue</MenuItem>
        </Select>
      </FormControl>

      {/* JSON Config */}
      <TextField
        fullWidth
        multiline
        minRows={6}
        label="Configuration JSON"
        value={jsonConfig}
        error={error}
        helperText={error ? "Invalid JSON" : "Enter any JSON config"}
        onChange={(e) => {
          const val = e.target.value;
          setJsonConfig(val);
          setError(!validateJson(val));
        }}
        onBlur={() => setJsonConfig(beautifyJson(jsonConfig))}
        sx={{ mt: 2 }}
      />

      {/* Buttons */}
      <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : isEdit ? "Update" : "Save"}
        </Button>

        <Button sx={{ ml: 1 }} onClick={handleClose}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentGatewayForm;